import useSelector from '@app/hooks/useSelector';

const useFeatureFlag = () => {
    const { documentTypeProjectV2Enabled, lionLfcFilesManagement, newProjectCreationModal } = useSelector(
        ({ features }) => ({
            documentTypeProjectV2Enabled: features.documentTypeProjectV2Enabled,
            lionLfcFilesManagement: features.lionLfcFilesManagement,
            newProjectCreationModal: features.newProjectCreationModal,
        }),
    );

    return { documentTypeProjectV2Enabled, lionLfcFilesManagement, newProjectCreationModal };
};

export default useFeatureFlag;
